import { render, staticRenderFns } from "./NvEmpty.vue?vue&type=template&id=bcbd3ab6&scoped=true&"
import script from "./NvEmpty.vue?vue&type=script&lang=js&"
export * from "./NvEmpty.vue?vue&type=script&lang=js&"
import style0 from "./NvEmpty.vue?vue&type=style&index=0&id=bcbd3ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbd3ab6",
  null
  
)

export default component.exports